(function () {
    'use strict';
    angular.module('app').controller('copytocurrent', copytocurrent);
    copytocurrent.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs'];
    function copytocurrent($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.ACN_CHECKER__ROLLBACK_REVISION = 10814;
        scope.xyz = { bReadyForOK: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // =====================================
        // On Load. Assign To.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedVersionsArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedVersionItem != scope.qualifiedVersionsBuildingList) {
                // Clear the array.
                scope.qualifiedVersionsArray = [];
                // Add 'building list' to the array.
                scope.qualifiedVersionsArray.push(scope.qualifiedVersionsBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedVersionItem = scope.qualifiedVersionsBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingVersionList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedVersionsArrayLoad = function (versions) {
            // Clear the array.
            scope.qualifiedVersionsArray = [];
            // Add 'pick one'.
            scope.qualifiedVersionsArray.push(scope.qualifiedVersionsPickOne);
            // Select 'pick one'.
            scope.xyz.selectedVersionItem = scope.qualifiedVersionsPickOne;
            // Add ''.
            //scope.qualifiedVersionsArray.push(scope.qualifiedVersionsBlank);
            // If there are items, ...
            if (versions != null && versions.list != null) {
                // Walk the items, ...
                angular.forEach(versions.list, function (ver) {
                    var display = "Version " + ver.majRev + "." + ver.minRev + " (" + ver.filename + ")";
                    // Add the item to the array.
                    scope.qualifiedVersionsArray.push({ id: ver, name: display, majRev: ver.majRev, minRev: ver.minRev})
                });
            }
            // We are done getting the items.
            scope.xyz.gettingVersionList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedVersionsBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedVersionsPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        //scope.qualifiedVersionsBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedVersionsArrayLoading();

        // =====================================
        //
        // =====================================  
        //
        // On user change.
        //
        scope.selectedVersionChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedVersionItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedVersionItem == scope.qualifiedVersionsPickOne)
                return;

            // Do Enables.
            scope.doEnables();
        };

        //
        // Enables.
        //
        scope.doEnables = function () {
            var bReady = false;
            if (scope.xyz.selectedVersionItem != null && scope.xyz.selectedVersionItem != scope.qualifiedVersionsPickOne)
                bReady = true;

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bReady;
        }

        //scope.comboFocus = function (event) {
        //    event.target.options.selectedIndex = -1;
        //}

        // On click of the Assign button.
        scope.onCopyToCurrentButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_CHECKER__ROLLBACK_REVISION;
            // PL-OBS? scope.xyz = { bReadyForOK: false, selectedUserItem: {} };

            scope.gridOptions.columnDefs = [{ name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' },
                { name: 'Version', field: 'version', width: '33%', minWidth: '100' }];

            // dialog config
            scope.heading = loginService.resourceStrings["COPY_TO_CURRENT"];
            scope.filesLabel = loginService.resourceStrings["COPY_TO_CURRENT_FILE_LABEL"];
            scope.versionLabel = loginService.resourceStrings["SCHEMA_S_VERSION"];
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For the first selection item, add a row to the grid.
            scope.gridOptions.data = [];
            var item = null;
            if (scope.slx.list != null && scope.slx.list.length > 0) {
                item = scope.slx.list[0];
                // Clean the list.
                var newList = [];
                newList.push(item);
                scope.slx.list = newList;
            }
            if (item != null) {
                var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
                if (item.detailedInfo.opFlag == O_OUT) {
                    scope.heading = scope.heading + " - " + loginService.resourceStrings["COPY_TO_CURRENT_OUT_WARNING"];
                }
                // Add item.
                scope.gridOptions.data.push({
                    index: 0,
                    selectionItem: item,
                    isSelected: true,
                    name: item.filename, library: item.detailedInfo.libName,
                    version: "" + item.majRev + "." + item.minRev
                });
            }

            // ============================
            // Select Item. Assign To.
            // ===========================+
            // Add users to the combo.
            scope.qualifiedVersionsArrayLoading();
            selectionCommandService.GetVersionsForCopyToCurrent(item.fileId).then(function (response) {
                scope.qualifiedVersionsArrayLoad(response.data);
            }, function (response) {
                scope.qualifiedVersionsArrayLoad();
                selectionCommandService.ShowEx(response); // Nothing more to do.
            });

            // Enables.
            // PL-OBS? scope.selectItem();
            // Do modal.
            // PL-OBS? scope.assignDialogShown = true;
            //$timeout(function () {
            //    refreshGrid();
            //    scope.gridApi.selection.selectAllRows();
            //    $timeout(function () {
            //        refreshGrid();
            //    }, 2000);
            //}, 500);
        };

      

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colVersion = loginService.resourceStrings["SCHEMA_S_VERSION"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colVersion;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onAssignDialogOK = function () {
            scope.xyz.processing = true;

            scope.slx.list[0].commandParams = {};
            scope.slx.list[0].commandParams.eMajRev = scope.xyz.selectedVersionItem.majRev;
            scope.slx.list[0].commandParams.eMinRev = scope.xyz.selectedVersionItem.minRev;

            // Execute.
            selectionCommandService.CopyToCurrent(scope.slx).then(function (response) {

                // When that  returns, ...
                var selectionCommandResults = response.data;

                // Call ACS to do the file operation.
                zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket, true).then(function (response) {
                }, function () {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });

                // Handle errors.
                var atLeastOneError = false;
                var selectionCommandResults = response.data;
                var slx = selectionCommandResults.slx;
                angular.forEach(slx.list, function (item) {
                    if (atLeastOneError == false) {
                        if (item.ec != 0) {
                            atLeastOneError = true;
                            if (atLeastOneError) {
                                commandService.launchErrors({ slx: slx });
                            }
                        }
                    }
                });
                // Close dialog and refresh grid.
                $mdDialog.hide();
                scope.xyz.processing = false;
                gridDataService.updateGridRecords(slx.list);

                editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
            }, function (response) {
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
            });
        };

        scope.onAssignDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.assignDialogClosed = function () {

        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            //gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            //gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            //after the grid has been initialized
            switch (command) {
                case "copytocurrent":
                    scope.onCopyToCurrentButtonClicked(records);
                    break;
            }

        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '33%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '33%', minWidth: '100' },
                { name: 'Version', field: 'version', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
